import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import startsWith from 'lodash/startsWith';
import { getAsyncInjectors } from 'helpers/asyncInjectors';
import { getSlug } from 'helpers/urlTools';
import { AccountSettings } from 'modules/Account';
import { AccountSetup } from 'modules/Setup';
import ClinicManagement, { AttachCloudDrive, ClinicSettings } from 'modules/ClinicManagement';
import CloudDrive from 'modules/CloudDrive';
import { PlainLayout } from 'modules/Layout';
import { loggedInGuard } from '../guards';
import { getLoader } from '../helpers';
async function action(context) {
    const { route, store, query, getUrl } = context;
    const Loader = getLoader(store);
    let Component = /*#__PURE__*/ _jsx(Loader, {});
    let SubComponent = null;
    let redirect;
    if (process.env.BROWSER) {
        redirect = await loggedInGuard(context);
        if (redirect) return {
            name: route.name,
            redirect
        };
        const { injectReducer, injectSagas } = getAsyncInjectors(store);
        if (query.code) {
            const decodedStateString = decodeURI(query.state).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"');
            const state = decodedStateString ? JSON.parse(`{"${decodedStateString}"}`) : {};
            if (state.type === 'pwd') {
                SubComponent = /*#__PURE__*/ _jsx(AccountSetup, {
                    isNoAutoRedirect: true
                });
                if (process.env.BROWSER) {
                    redirect = getUrl('setup');
                }
            } else if (state.type === 'pwdReAuth') {
                SubComponent = /*#__PURE__*/ _jsx(AccountSettings, {
                    view: "patientProfile",
                    views: [
                        'settings',
                        'patientProfile',
                        'dataSources'
                    ]
                });
                if (process.env.BROWSER) {
                    redirect = getUrl('account-settings-view', {
                        view: 'patientProfile'
                    });
                }
            } else if (state.type === 'clinic') {
                injectReducer(ClinicManagement.constants.MODULE_ID, ClinicManagement.reducer);
                SubComponent = /*#__PURE__*/ _jsx(AttachCloudDrive, {});
                if (process.env.BROWSER) {
                    redirect = getUrl('add-drive');
                }
            } else if (startsWith(state.type, 'clinicReAuth')) {
                injectReducer(ClinicManagement.constants.MODULE_ID, ClinicManagement.reducer);
                injectSagas(ClinicManagement.constants.MODULE_ID, ClinicManagement.sagas);
                const props = state.type.split('-');
                const organizationUID = props.slice(1, 6).join('-');
                const clinicSlug = getSlug(props.slice(6).join('-'));
                SubComponent = /*#__PURE__*/ _jsx(ClinicSettings, {
                    organizationUID: organizationUID,
                    view: "dataSettings",
                    views: [
                        'memberships',
                        'phiSettings',
                        'dataSettings'
                    ]
                });
                if (process.env.BROWSER) {
                    redirect = getUrl('clinic-settings-view', {
                        clinicSlug,
                        organizationUID,
                        view: 'dataSettings'
                    });
                }
            }
            if (SubComponent) {
                Component = /*#__PURE__*/ _jsx(PlainLayout, {
                    children: SubComponent
                });
            }
            await store.dispatch(CloudDrive.actions.authorizeCheck(query.code, 'GoogleDrive', query.scope));
        }
    }
    return {
        chunks: [
            'account'
        ],
        name: route.name,
        redirect,
        component: Component
    };
}
export default action;
